"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnairePathTraversal = void 0;
var lodash_1 = require("lodash");
var publish_1 = require("../logic/publish");
var respondent_path_validity_1 = require("./model/respondent-path-validity");
var error_codes_1 = require("./error-codes");
var error_levels_1 = require("./error-levels");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var array_utils_1 = require("../util/array-utils");
var graph_1 = require("../util/graph");
var publish_2 = require("../questionnaire/publish");
var constants_1 = require("../constants");
var QuestionnairePathTraversal = /** @class */ (function () {
    function QuestionnairePathTraversal(questionnaireLogicService) {
        this.questionnaireLogicService = questionnaireLogicService;
    }
    QuestionnairePathTraversal.prototype.validateSurveyCompletion = function (ql, knowledge) {
        var _a, _b;
        if (lodash_1.isEmpty(knowledge)) {
            throw new advanced_logic_error_1.AdvancedLogicError('Invalid knowledge.');
        }
        if (lodash_1.isEmpty(knowledge.questionAnswers)) {
            return new respondent_path_validity_1.RespondentPathValidity({
                valid: false,
                nodeId: constants_1.FinalNode,
            });
        }
        var firstOutcome = this.questionnaireLogicService.getNextOutcomeForEntryPoint(ql.entryPoint, knowledge);
        var currentOutcome = firstOutcome;
        var visitedNodes = [];
        var answeredQuestions = knowledge.questionAnswers.map(function (_a) {
            var conceptId = _a.conceptId, questionId = _a.questionId;
            if (conceptId) {
                return questionId + ":" + conceptId;
            }
            return questionId;
        });
        var missingQuestionAnswer;
        var hasKnowledgeConcepts = knowledge.concepts && !lodash_1.isEmpty(knowledge.concepts);
        var _loop_1 = function () {
            var node = publish_2.Questionnaire.getNode(ql.questionnaire, currentOutcome.params.id);
            // if (!node) {
            //   throw new Error(`Found no node with id ${currentNodeId}`);
            // }
            var expectedConceptsForNode = void 0;
            if (publish_2.isGroup(node) && hasKnowledgeConcepts) {
                expectedConceptsForNode = knowledge.concepts.find(function (concept) { return concept.nodeId === currentOutcome.params.id; });
            }
            if (publish_2.isGroup(node)) {
                // we are expected to have a { questionId, conceptId } pair for each questionId answered
                // for every different concept combinations that have also been answered.
                // ie: for a sequential AB group with 2 repetitions, we expect
                // [{ questionId: 'question-1', conceptId: 'concept-1' },{ questionId: 'question-1', conceptId: 'concept-2'}]
                // concept-1 and concept-2 string ids are being derived from the knowledge.concepts schema provided as an input
                if (expectedConceptsForNode) {
                    var repetitions = node.repetitions || 1; // this exists for backwards compatibility
                    if (repetitions !== expectedConceptsForNode.conceptIds.length) {
                        return { value: new respondent_path_validity_1.RespondentPathValidity({
                                valid: false,
                                nodeId: node.id,
                                reason: "Node " + node.id + " was expected to have " + node.repetitions + " concepts but received " + expectedConceptsForNode.conceptIds.length,
                            }) };
                    }
                    // verifies that for each concept expected, we have all subnodes answered for given concept
                    var expectedConceptIds = expectedConceptsForNode === null || expectedConceptsForNode === void 0 ? void 0 : expectedConceptsForNode.conceptIds;
                    if (expectedConceptIds) {
                        var missingNode_1;
                        expectedConceptIds.some(function (conceptId) {
                            var _a;
                            missingNode_1 = (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.find(function (subNode) {
                                return !answeredQuestions.includes(subNode.id + ":" + conceptId);
                            });
                            // bails when it finds a missing node so that it doesn't get overwritten with an undefined value later
                            return missingNode_1;
                        });
                        if (missingNode_1) {
                            return { value: new respondent_path_validity_1.RespondentPathValidity({
                                    valid: false,
                                    nodeId: missingNode_1.id,
                                    reason: "Node " + missingNode_1.id + " was expected to have been answered for concepts " + expectedConceptIds + " but it was not",
                                }) };
                        }
                    }
                }
                else {
                    var missingNode = (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.find(function (subNode) { return !answeredQuestions.includes(subNode.id); });
                    if (missingNode) {
                        missingQuestionAnswer = missingNode.id;
                        return "break";
                    }
                }
            }
            else if (!answeredQuestions.includes(currentOutcome.params.id)) {
                missingQuestionAnswer = currentOutcome.params.id;
                return "break";
            }
            if (visitedNodes.includes(currentOutcome.params.id)) {
                return { value: new respondent_path_validity_1.RespondentPathValidity({
                        valid: false,
                        nodeId: currentOutcome.params.id,
                    }) };
            }
            if (publish_2.isGroup(node)) {
                if (expectedConceptsForNode) {
                    var expectedConceptIds = expectedConceptsForNode === null || expectedConceptsForNode === void 0 ? void 0 : expectedConceptsForNode.conceptIds;
                    expectedConceptIds === null || expectedConceptIds === void 0 ? void 0 : expectedConceptIds.forEach(function (conceptId) {
                        var _a;
                        (_a = node.nodes) === null || _a === void 0 ? void 0 : _a.every(function (subNode) {
                            return visitedNodes.push(subNode.id + ":" + conceptId);
                        });
                    });
                }
                else {
                    (_b = node.nodes) === null || _b === void 0 ? void 0 : _b.every(function (subNode) { return visitedNodes.push(subNode.id); });
                }
            }
            else {
                visitedNodes.push(currentOutcome.params.id);
            }
            var nextOutcome = this_1.questionnaireLogicService.getOutcomeForNode(ql, knowledge, currentOutcome.params.id);
            currentOutcome = nextOutcome;
        };
        var this_1 = this;
        while (currentOutcome.params.id !== constants_1.FinalNode) {
            var state_1 = _loop_1();
            if (typeof state_1 === "object")
                return state_1.value;
            if (state_1 === "break")
                break;
        }
        if (missingQuestionAnswer) {
            return new respondent_path_validity_1.RespondentPathValidity({
                valid: false,
                nodeId: missingQuestionAnswer,
            });
        }
        // check if we reached the end due to FAILURE outcome
        if (currentOutcome.reason) {
            return new respondent_path_validity_1.RespondentPathValidity({
                valid: false,
                nodeId: undefined,
                reason: currentOutcome.reason,
            });
        }
        // We are checking that all questions answered by the respondent were also
        // visited by the validation traversal. This helps us catch errors where
        // we got extra questions answered by a respondent that which can happen due
        // to errors on the backend (sending us invalid paths due to respondents taking more than
        // one path). PUB-2685
        var extraQuestions = lodash_1.xor(visitedNodes, answeredQuestions);
        var isPathValid = lodash_1.isEmpty(extraQuestions);
        var hasExtraQuestions = !lodash_1.isEmpty(extraQuestions);
        var reason;
        if (!isPathValid && hasExtraQuestions) {
            reason = 'extra_questions';
        }
        return new respondent_path_validity_1.RespondentPathValidity({
            valid: isPathValid,
            nodeId: hasExtraQuestions ? lodash_1.first(extraQuestions) : undefined,
            reason: reason,
        });
    };
    QuestionnairePathTraversal.prototype.findMaxLength = function (ql) {
        return this.findLongestPathLength(ql);
    };
    QuestionnairePathTraversal.prototype.prepareErrors = function (skippedNodes, cyclicNodes, nodesWithWrongContext, indexToIdMap) {
        var errors = [];
        if (!lodash_1.isEmpty(skippedNodes)) {
            errors.push({
                message: "Questionnaire contains " + skippedNodes.length + " unused nodes",
                details: graph_1.addRefIdsToNodes(skippedNodes, indexToIdMap),
                code: error_codes_1.VALIDATION_ERRORS.UNUSED_NODES,
                level: error_levels_1.VALIDATION_ERROR_LEVELS.WARNING,
            });
        }
        Object.keys(cyclicNodes).forEach(function (fromNodeIndex) {
            // @ts-ignore nodeIndex string but cyclicNodes has key type number but arrays indexes can accessed by string
            cyclicNodes[fromNodeIndex].forEach(function (toNodeIndex) {
                // @ts-ignore
                var fromNodeRefId = indexToIdMap[fromNodeIndex];
                var toNodeRefId = indexToIdMap[toNodeIndex];
                errors.push({
                    nodeId: fromNodeRefId,
                    message: "Node " + fromNodeRefId + " contains a circle. (" + fromNodeRefId + "->" + toNodeRefId + ")",
                    details: { from: fromNodeRefId, to: toNodeRefId },
                    code: error_codes_1.VALIDATION_ERRORS.CIRCLE,
                    level: error_levels_1.VALIDATION_ERROR_LEVELS.BLOCKING,
                });
            });
        });
        Object.keys(nodesWithWrongContext).forEach(function (nodeRefId) {
            return nodesWithWrongContext[nodeRefId].forEach(function (unansweredNodeRefId) {
                errors.push({
                    nodeId: nodeRefId,
                    message: "Node " + nodeRefId + " references a node that is not previously answered",
                    details: {
                        unansweredNode: unansweredNodeRefId,
                    },
                    code: error_codes_1.VALIDATION_ERRORS.WRONG_CONTEXT_REFERENCE,
                    level: error_levels_1.VALIDATION_ERROR_LEVELS.WARNING,
                });
            });
        });
        return errors;
    };
    QuestionnairePathTraversal.prototype.analyzeGraphPaths = function (ql) {
        var graph = this.analyzeGraph(ql);
        var groupNodes = graph.groupNodes, subNodes = graph.subNodes, adjacencyList = graph.adjacencyList, indexToIdMap = graph.indexToIdMap, idToIndexMap = graph.idToIndexMap, ancestors = graph.ancestors, skippedNodes = graph.skippedNodes, cyclicNodes = graph.cyclicNodes;
        var nodeStatements = lodash_1.get(ql, 'nodeStatements', []);
        var referencingAdjacencyList = this.generateReferencingAdjacencyList(nodeStatements, idToIndexMap);
        var previousNodesPerNode = graph_1.getPreviousNodes(ancestors, indexToIdMap, skippedNodes, groupNodes, subNodes);
        var nodesWithWrongContext = graph_1.findNodesWithWrongContext(ancestors, referencingAdjacencyList, indexToIdMap);
        return {
            previousNodesPerNode: previousNodesPerNode,
            logicPaths: this.getLogicPathsFromQl(ql),
            adjacencyList: this.addRefIdsToAdjastencyList(adjacencyList, indexToIdMap),
            maxPathLength: this.findLongestPathLength(ql, graph),
            errors: this.prepareErrors(skippedNodes, cyclicNodes, nodesWithWrongContext, indexToIdMap),
        };
    };
    // deprecated validate which use the findPossiblePaths
    QuestionnairePathTraversal.prototype.validateForWarnings = function (ql, possiblePaths) {
        if (!possiblePaths) {
            possiblePaths = this.findPossiblePaths({ ql: ql });
        }
        var _a = possiblePaths.errors, errors = _a === void 0 ? [] : _a, _b = possiblePaths.visitedNodes, visitedNodes = _b === void 0 ? [] : _b;
        var nodes = lodash_1.get(ql, 'questionnaire.nodes', []);
        var unusedNodes = nodes.filter(function (node) { return !visitedNodes.includes(node.id); });
        var unusedNodeIds = unusedNodes.map(function (node) { return node.id; });
        if (!lodash_1.isEmpty(unusedNodes)) {
            errors.push({
                message: "Questionnaire contains " + unusedNodes.length + " unused nodes",
                details: unusedNodeIds,
                code: error_codes_1.VALIDATION_ERRORS.UNUSED_NODES,
                level: error_levels_1.VALIDATION_ERROR_LEVELS.WARNING,
            });
        }
        return {
            errors: errors,
        };
    };
    // used only by adl-microservice
    QuestionnairePathTraversal.prototype.validate = function (ql) {
        var hasCycles = this.detectCycles(ql).hasCycles;
        var errors = [];
        if (hasCycles) {
            errors.push({
                message: 'Graph contains at least one circle.',
                code: error_codes_1.VALIDATION_ERRORS.CIRCLE,
                level: error_levels_1.VALIDATION_ERROR_LEVELS.BLOCKING,
            });
        }
        return {
            errors: errors,
        };
    };
    QuestionnairePathTraversal.prototype.findPossiblePaths = function (options) {
        var ql = options.ql, _a = options.shouldIncludeAllPaths, shouldIncludeAllPaths = _a === void 0 ? true : _a, _b = options.shouldCalculatePreviousNodes, shouldCalculatePreviousNodes = _b === void 0 ? true : _b;
        var nodes = lodash_1.get(ql, 'questionnaire.nodes', []);
        var nodeStatements = lodash_1.get(ql, 'nodeStatements', []);
        // performance optimisation. refIds are uuid strings and consume A LOT of
        // memory/cpu when searching/adding on the graph. This function helps by converting
        // refIds:string to numbered indexes
        var _c = this.generateNodeRefIdTransformationMaps(nodes), idToIndexMap = _c.idToIndexMap, indexToIdMap = _c.indexToIdMap, nodesWeight = _c.nodesWeight, groupNodes = _c.groupNodes;
        var adjacencyList = this.generateAdjacencyList(nodeStatements, idToIndexMap);
        var entryQuestionId = lodash_1.get(ql, 'entryPoint.statements[0].outcome.params.id', constants_1.FinalNode);
        var referencingAdjacencyList = this.generateReferencingAdjacencyList(nodeStatements, idToIndexMap);
        var logicPaths = this.getLogicPathsFromQl(ql);
        var startPathFromNode = idToIndexMap[entryQuestionId];
        var finalNode = 0;
        var _d = this.getPathsFromAdjacencyList(startPathFromNode, finalNode, indexToIdMap, adjacencyList, referencingAdjacencyList, nodesWeight, shouldIncludeAllPaths, shouldCalculatePreviousNodes, groupNodes), _e = _d.allPaths, allPaths = _e === void 0 ? [] : _e, _f = _d.pathsWithErrors, pathsWithErrors = _f === void 0 ? [] : _f, _g = _d.visitedNodes, visitedNodes = _g === void 0 ? [] : _g, _h = _d.errors, errors = _h === void 0 ? [] : _h, maxPathLength = _d.maxPathLength, previousNodesPerNode = _d.previousNodesPerNode;
        return {
            logicPaths: logicPaths,
            allPaths: allPaths,
            previousNodesPerNode: previousNodesPerNode,
            pathsWithErrors: pathsWithErrors,
            visitedNodes: visitedNodes,
            errors: errors,
            maxPathLength: maxPathLength,
            adjacencyList: this.addRefIdsToAdjastencyList(adjacencyList, indexToIdMap),
            referencingAdjacencyList: this.addRefIdsToAdjastencyList(referencingAdjacencyList, indexToIdMap),
        };
    };
    QuestionnairePathTraversal.prototype.addRefIdsToAdjastencyList = function (list, indexToIdMap) {
        return Object.keys(list).reduce(function (accumulator, key) {
            var nodeId = indexToIdMap[key];
            accumulator[nodeId] = list[key].map(function (nodeIndex) { return indexToIdMap[nodeIndex] || constants_1.FinalNode; });
            return accumulator;
        }, {});
    };
    // gets a node and returns it's neighbors
    // ie: in a graph 1 -> 2 -> 4 -> 5 -> 0
    //                  -> 3 -> ^
    //     we need to return { 1: [2, 3], 2: [4], 3: [4], 4: [5], 5: [0] }
    QuestionnairePathTraversal.prototype.generateAdjacencyList = function (nodeStatements, idToIndex) {
        var adjacencyList = {};
        nodeStatements.forEach(function (_a) {
            var nodeId = _a.nodeId, statements = _a.statements;
            var indexId = idToIndex[nodeId];
            var neighbours = adjacencyList[indexId] || [];
            statements.forEach(function (statement) {
                var nextNodeId = lodash_1.get(statement, 'outcome.params.id');
                neighbours.push(idToIndex[nextNodeId] || 0);
            });
            adjacencyList[indexId.toString()] = lodash_1.uniq(neighbours);
        });
        return adjacencyList;
    };
    // gets a node and returns the nodes it's referencing through statement/rules
    // ie: given a questionnaire [Node1, Node2] then
    //     if Node2 is referencing Node1 in _any_ of its own rules then we need to return
    //     { Node1: [], Node2: [Node1] }
    QuestionnairePathTraversal.prototype.generateReferencingAdjacencyList = function (nodeStatements, idToIndex) {
        var _this = this;
        var adjacencyList = {};
        nodeStatements.forEach(function (_a) {
            var nodeId = _a.nodeId, statements = _a.statements;
            var indexId = idToIndex[nodeId];
            var neighbours = adjacencyList[indexId] || [];
            statements.forEach(function (statement) {
                if (statement.rule) {
                    var ruleConditions = _this.questionnaireLogicService.ruleService.getConditions(statement.rule);
                    ruleConditions.forEach(function (condition) {
                        var _a, _b;
                        // TODO: We should introduce in the future a single way of handling referencing nodes
                        //       ie. name everything referenceNodeId or nodeId
                        if (((_a = condition.context) === null || _a === void 0 ? void 0 : _a.contextType) ===
                            publish_1.QuestionnaireConditionContext.Answer &&
                            idToIndex[condition.context.questionId] !== indexId) {
                            neighbours.push(idToIndex[condition.context.questionId]);
                        }
                        else if (((_b = condition.context) === null || _b === void 0 ? void 0 : _b.contextType) ===
                            publish_1.QuestionnaireConditionContext.Concept &&
                            idToIndex[condition.context.nodeId] !== indexId) {
                            neighbours.push(idToIndex[condition.context.nodeId]);
                        }
                    });
                }
            });
            adjacencyList[indexId.toString()] = lodash_1.uniq(neighbours);
        });
        return adjacencyList;
    };
    QuestionnairePathTraversal.prototype.generateNodeRefIdTransformationMaps = function (nodes) {
        var idToIndex = {};
        var indexToId = [];
        var nodesWeight = [];
        var groupNodes = {};
        var subNodes = {};
        // we reserve 0 for the end of survey
        var indexCounter = 1;
        nodes.forEach(function (node) {
            var nodeIndex = indexCounter;
            idToIndex[node.id] = nodeIndex;
            indexToId[nodeIndex] = node.id;
            indexCounter += 1;
            var weight = 1;
            if (publish_2.isGroup(node)) {
                node.nodes.forEach(function (subNode) {
                    var subNodeIndexId = indexCounter;
                    indexCounter += 1;
                    idToIndex[subNode.id] = subNodeIndexId;
                    indexToId[subNodeIndexId] = subNode.id;
                    if (!groupNodes[nodeIndex]) {
                        groupNodes[nodeIndex] = [];
                    }
                    groupNodes[nodeIndex].push(subNodeIndexId);
                    //map subNodes to parent group node
                    subNodes[subNodeIndexId] = nodeIndex;
                });
            }
            if (publish_2.isGroup(node) && node.repetitions) {
                weight = node.nodes.length * node.repetitions;
            }
            else if (node.nodes) {
                weight = node.nodes.length;
            }
            nodesWeight[nodeIndex] = weight;
        });
        return {
            idToIndexMap: idToIndex,
            indexToIdMap: indexToId,
            nodesWeight: nodesWeight,
            groupNodes: groupNodes,
            subNodes: subNodes,
        };
    };
    QuestionnairePathTraversal.prototype.getPathsFromAdjacencyList = function (root, finalNode, indexToId, neighbourNodesAdjustencyList, referencingNodesAdjacencyList, nodesWeight, shouldIncludeAllPaths, shouldCalculatePreviousNodes, groupNodes) {
        if (indexToId === void 0) { indexToId = []; }
        var allPaths = [];
        var pathsWithErrors = [];
        var errors = [];
        var visitedNodes = {};
        var previousNodesPerNode = {};
        var traverse = function (node, pathSoFar) {
            if (node === null || node === undefined) {
                // it comes from a loop
                if (shouldIncludeAllPaths) {
                    allPaths.push(pathSoFar);
                }
                pathsWithErrors.push(pathSoFar);
                return;
            }
            visitedNodes[node] = true;
            if (shouldCalculatePreviousNodes) {
                if (!previousNodesPerNode[node]) {
                    previousNodesPerNode[node] = new Set();
                }
                pathSoFar.forEach(function (nodeId) {
                    var isNodeAGroup = !!groupNodes[nodeId];
                    // we want to prepend the subnodes to the group node so
                    // a survey that is Q1 -> AB(Q2.1, Q2.2) will return [Q1, Q2.1, Q2.2, AB] in the series
                    // the reason is that we will be evaluating that an AB group is finished when all the internal questions
                    // are finished as well.
                    if (isNodeAGroup) {
                        var groupSubNodes_1 = groupNodes[nodeId];
                        var previousNodesUntilNow_1 = Array.from(previousNodesPerNode[nodeId]).filter(function (prevNode) { return !groupSubNodes_1.includes(prevNode); });
                        groupNodes[nodeId].reduce(function (accumulator, subNodeId) {
                            previousNodesPerNode[node].add(subNodeId);
                            previousNodesPerNode[subNodeId] = new Set(__spreadArrays(previousNodesUntilNow_1, accumulator));
                            accumulator.push(subNodeId);
                            return accumulator;
                        }, []);
                    }
                    if (nodeId !== node) {
                        previousNodesPerNode[node].add(nodeId);
                    }
                });
            }
            if (node === finalNode) {
                if (shouldIncludeAllPaths) {
                    allPaths.push(pathSoFar);
                }
                return;
            }
            var referencedNodes = referencingNodesAdjacencyList[node] || [];
            var unansweredNode = referencedNodes.find(function (referencedNode) { return !pathSoFar.includes(referencedNode); });
            if (unansweredNode) {
                var nodeRefId = indexToId[node];
                var unansweredNodeRefId = indexToId[unansweredNode];
                errors.push({
                    nodeId: nodeRefId,
                    message: "Node " + nodeRefId + " references a node that is not previously answered",
                    details: {
                        unansweredNode: unansweredNodeRefId,
                    },
                    code: error_codes_1.VALIDATION_ERRORS.WRONG_CONTEXT_REFERENCE,
                    level: error_levels_1.VALIDATION_ERROR_LEVELS.WARNING,
                });
            }
            for (var _i = 0, _a = neighbourNodesAdjustencyList[node]; _i < _a.length; _i++) {
                var neighbour = _a[_i];
                var newPathSoFar = array_utils_1.optimisedArrayAdd(pathSoFar, neighbour);
                if (pathSoFar.includes(neighbour)) {
                    // handle loop
                    var nodeRefId = indexToId[node];
                    var neighbourRefId = indexToId[neighbour];
                    errors.push({
                        nodeId: nodeRefId,
                        message: "Node " + nodeRefId + " contains a circle. (" + nodeRefId + "->" + neighbourRefId + ")",
                        details: { from: nodeRefId, to: neighbourRefId },
                        code: error_codes_1.VALIDATION_ERRORS.CIRCLE,
                        level: error_levels_1.VALIDATION_ERROR_LEVELS.BLOCKING,
                    });
                    traverse(null, newPathSoFar);
                }
                else {
                    traverse(neighbour, newPathSoFar);
                }
            }
        };
        traverse(root, [root]);
        var fixedPathsWithErrors = pathsWithErrors.map(function (path) {
            return path.map(function (indexId) { return indexToId[indexId] || constants_1.FinalNode; });
        });
        var fixedVisitedNodes = [];
        var fixedPreviousNodes = {};
        Object.keys(visitedNodes).forEach(function (nodeId) {
            var nodeRefId = indexToId[Number(nodeId)] || constants_1.FinalNode;
            fixedVisitedNodes.push(nodeRefId);
            if (shouldCalculatePreviousNodes) {
                fixedPreviousNodes[nodeRefId] = [];
                previousNodesPerNode[nodeId].forEach(function (previousNodeId) {
                    var isNodeAGroup = !!groupNodes[Number(nodeId)];
                    if (isNodeAGroup) {
                        // this could be probably also written with a recursive function
                        groupNodes[Number(nodeId)].forEach(function (subNodeStringId) {
                            var subNodeId = Number(subNodeStringId);
                            var subNodeRefId = indexToId[subNodeId] || constants_1.FinalNode;
                            fixedPreviousNodes[subNodeRefId] = [];
                            previousNodesPerNode[subNodeId].forEach(function (previousNodeId) {
                                var previousNodeRefId = indexToId[Number(previousNodeId)] || constants_1.FinalNode;
                                fixedPreviousNodes[subNodeRefId].push(previousNodeRefId);
                            });
                        });
                    }
                    var previousNodeRefId = indexToId[Number(previousNodeId)] || constants_1.FinalNode;
                    fixedPreviousNodes[nodeRefId].push(previousNodeRefId);
                });
            }
        });
        var returnObject = {
            previousNodesPerNode: fixedPreviousNodes,
            allPaths: [],
            pathsWithErrors: fixedPathsWithErrors,
            visitedNodes: fixedVisitedNodes,
            errors: errors,
            maxPathLength: 0,
        };
        if (shouldIncludeAllPaths) {
            // transform the paths back to refIds
            var maxPathLength_1 = 0;
            var fixedAllPaths = allPaths.map(function (path) {
                var pathLength = 0;
                var visitedNodes = {};
                var newPath = path.map(function (indexId) {
                    if (!visitedNodes[indexId]) {
                        visitedNodes[indexId] = true;
                        pathLength += nodesWeight[indexId] || 0;
                    }
                    return indexToId[indexId] || constants_1.FinalNode;
                });
                if (pathLength > maxPathLength_1) {
                    maxPathLength_1 = pathLength;
                }
                return newPath;
            });
            returnObject.allPaths = fixedAllPaths;
            returnObject.maxPathLength = maxPathLength_1;
        }
        return returnObject;
    };
    QuestionnairePathTraversal.prototype.getLogicPathsFromQl = function (ql) {
        var destinationPaths = ql.nodeStatements.map(function (_a) {
            var nodeId = _a.nodeId, statements = _a.statements;
            var destinationNodes = statements.map(function (statement) { return ({
                id: statement.outcome.params.id,
                reachedByRule: Boolean(statement.rule),
                reason: statement.outcome.reason,
            }); });
            var uniqueDestinationNodes = lodash_1.uniqWith(destinationNodes, lodash_1.isEqual);
            return {
                fromNode: nodeId,
                toNodes: uniqueDestinationNodes,
            };
        });
        var logicPaths = destinationPaths.reduce(function (exploded, destinationPath) {
            var _a;
            var nodeIndex = ql.questionnaire.nodes.findIndex(function (node) { return node.id === destinationPath.fromNode; });
            var nextNodeId = ((_a = ql.questionnaire.nodes[nodeIndex + 1]) === null || _a === void 0 ? void 0 : _a.id) || constants_1.FinalNode;
            destinationPath.toNodes.forEach(function (destinationNode) {
                if (destinationNode.reachedByRule ||
                    destinationNode.id !== nextNodeId) {
                    exploded.push([
                        destinationPath.fromNode,
                        destinationNode.id,
                        destinationNode.reason || '',
                    ]);
                }
            });
            return exploded;
        }, []);
        return logicPaths;
    };
    QuestionnairePathTraversal.prototype.findLongestPathLength = function (ql, graph) {
        var _a = graph || this.analyzeGraph(ql), numOfNodes = _a.numOfNodes, nodesWeight = _a.nodesWeight, groupNodes = _a.groupNodes, subNodes = _a.subNodes, adjacencyList = _a.adjacencyList, skippedNodes = _a.skippedNodes;
        return this.findLongestPath(adjacencyList, numOfNodes, nodesWeight, groupNodes, subNodes, skippedNodes);
    };
    QuestionnairePathTraversal.prototype.analyzeGraphInitial = function (ql) {
        var nodeStatements = lodash_1.get(ql, 'nodeStatements', []);
        var nodes = lodash_1.get(ql, 'questionnaire.nodes', []);
        var _a = this.generateNodeRefIdTransformationMaps(nodes), idToIndexMap = _a.idToIndexMap, indexToIdMap = _a.indexToIdMap, nodesWeight = _a.nodesWeight, groupNodes = _a.groupNodes, subNodes = _a.subNodes;
        var numOfNodes = graph_1.findNumberOfNodes(nodes);
        var adjacencyList = this.generateAdjacencyList(nodeStatements, idToIndexMap);
        return {
            idToIndexMap: idToIndexMap,
            indexToIdMap: indexToIdMap,
            nodesWeight: nodesWeight,
            groupNodes: groupNodes,
            subNodes: subNodes,
            numOfNodes: numOfNodes,
            adjacencyList: adjacencyList,
        };
    };
    QuestionnairePathTraversal.prototype.analyzeGraph = function (ql) {
        var _a = this.analyzeGraphInitial(ql), indexToIdMap = _a.indexToIdMap, idToIndexMap = _a.idToIndexMap, nodesWeight = _a.nodesWeight, groupNodes = _a.groupNodes, subNodes = _a.subNodes, numOfNodes = _a.numOfNodes, adjacencyList = _a.adjacencyList;
        var _b = graph_1.getAncestors(adjacencyList, idToIndexMap, subNodes), ancestors = _b.ancestors, cyclicNodes = _b.cyclicNodes;
        var skippedNodes = graph_1.getSkippedNodes(ql, ancestors, idToIndexMap, subNodes);
        return {
            numOfNodes: numOfNodes,
            nodesWeight: nodesWeight,
            groupNodes: groupNodes,
            subNodes: subNodes,
            adjacencyList: adjacencyList,
            indexToIdMap: indexToIdMap,
            idToIndexMap: idToIndexMap,
            ancestors: ancestors,
            skippedNodes: skippedNodes,
            cyclicNodes: cyclicNodes,
        };
    };
    QuestionnairePathTraversal.prototype.findLongestPath = function (adjacencyList, numOfNodes, nodeWeights, groupNodes, subNodes, skippedNodes) {
        if (numOfNodes == null) {
            return 0;
        }
        var nodePathVal = Array(numOfNodes + 1).fill(0);
        var visited = Array(numOfNodes + 1).fill(false);
        for (var index = 1; index <= numOfNodes; index++) {
            // skip nodes that belong inside a group node and not used
            if (!visited[index] &&
                !subNodes[index] &&
                !skippedNodes.includes(index)) {
                this.dfs(index, adjacencyList, nodePathVal, visited, nodeWeights, groupNodes);
            }
        }
        return Math.max.apply(Math, nodePathVal);
    };
    QuestionnairePathTraversal.prototype.dfs = function (node, adjacencyList, nodePathVal, visited, nodeWeights, groupNodes) {
        if (node == 0) {
            return;
        }
        visited[node] = true;
        // Traverse all  children
        for (var child in adjacencyList[node]) {
            if (!visited[adjacencyList[node][child]]) {
                this.dfs(adjacencyList[node][child], adjacencyList, nodePathVal, visited, nodeWeights, groupNodes);
            }
            nodePathVal[node] = Math.max(nodePathVal[node], nodeWeights[node] + nodePathVal[adjacencyList[node][child]]);
        }
    };
    QuestionnairePathTraversal.prototype.detectCycles = function (ql) {
        var _a = this.analyzeGraphInitial(ql), numOfNodes = _a.numOfNodes, adjacencyList = _a.adjacencyList;
        var visited = [];
        var recStack = [];
        for (var i = 1; i <= numOfNodes; i++) {
            visited[i] = false;
            recStack[i] = false;
        }
        for (var y = 1; y <= numOfNodes; y++) {
            if (this.isCyclic(y, visited, recStack, adjacencyList)) {
                return {
                    hasCycles: true,
                    recordStack: recStack,
                };
            }
        }
        return {
            hasCycles: false,
            recordStack: [],
        };
    };
    QuestionnairePathTraversal.prototype.isCyclic = function (i, visited, recStack, adjacencyList) {
        if (recStack[i]) {
            return true;
        }
        if (visited[i]) {
            return false;
        }
        visited[i] = true;
        recStack[i] = true;
        var children = adjacencyList[i];
        for (var child in children) {
            if (this.isCyclic(children[child], visited, recStack, adjacencyList)) {
                return true;
            }
        }
        recStack[i] = false;
        return false;
    };
    return QuestionnairePathTraversal;
}());
exports.QuestionnairePathTraversal = QuestionnairePathTraversal;
